import {
    Avatar,
    Button,
    FormHelperText,
    Grid,
    IconButton,
    Typography,
    useTheme,
  } from "@mui/material";
  import React, { useEffect, useLayoutEffect, useState } from "react";
  import { useDropzone } from "react-dropzone";
  import useStyle from "./style";
  import BackspaceIcon from "@mui/icons-material/Backspace";
  import { useSelector } from "react-redux";
  
  const DropZone = ({ formik, previewImg, isEdit, setPreviweImg }) => {
    const classes = useStyle();
    const theme = useTheme();
    const isFlag = useSelector((state) => state.workflow);
    const [edit, setEdit] = useState(false);
    const { acceptedFiles, getRootProps, getInputProps, fileRejections } =
      useDropzone({
        onDrop: (acceptedFiles) => {
          formik.setFieldValue(
            "logo",
            acceptedFiles.map((file) =>
              Object.assign(file, {
                preview: URL.createObjectURL(file),
              })
            )
          );
          setEdit(true);
        },
        accept: {
          "image/*": [],
        },
        multiple: false,
        maxFiles: 1,
        maxSize: 2097152,
      });
  
    const files = acceptedFiles.map((file) => (
      <div key={file.path}>
        {file.path} - {parseFloat(file.size / 1048576).toFixed(2)} mb
      </div>
    ));
  
    const fileRejectionItems = fileRejections.map(({ file, errors }) => (
      <div key={file.path}>
        <div>
          {errors.map((e) => (
            <div key={e.code}>
              {e.code === "file-too-large" ? (
                <Typography sx={{ color: "red" }}>
                  Maximum upload file size: 2 MB
                </Typography>
              ) : e.code === "file-invalid-type" ? (
                <Typography color={theme.palette.error.main}>
                  .jpg,.jpeg,.png files only supported
                </Typography>
              ) : (
                <Typography color={theme.palette.error.main}>
                  {e.message}
                </Typography>
              )}
            </div>
          ))}
        </div>
      </div>
    ));
  
    const validateImg = (
      <FormHelperText sx={{ color: theme.palette.error.main }}>
        {formik.touched.logo && formik.errors.logo}
      </FormHelperText>
    );
    const handleRemoveImg = () => {
      formik.setFieldValue("logo", []);
      setEdit(false);
      setPreviweImg(null);
    };
    // useEffect(() => {
    //   if (formik.values.logo.length === 0) {
    //     setEdit(false);
    //   } else {
    //     setEdit(true);
    //   }
    // }, [formik.values.logo]);
  
    useLayoutEffect(() => {
      if (isEdit) {
        setEdit(true);
      }
    }, []);
  
    console.log(previewImg, "edit");
    console.log(`${process.env.REACT_APP_IMG_URL}/${previewImg}`)
    return (
      <Grid container>
        <Grid item>
          {isEdit && previewImg != null ? (
            <Avatar
              variant="square"
              className={classes.companyLogo}
              src={`${process.env.REACT_APP_IMG_URL}/${previewImg}`}
            />
          ) : edit ? (
            formik.values.logo.map((val) => (
              <div style={{ display: "flex" }} key={val.name}>
                <Avatar
                  variant="square"
                  className={classes.companyLogo}
                  src={val.preview}
                  onLoad={() => {
                    URL.revokeObjectURL(val.preview);
                  }}
                />
              </div>
            ))
          ) : (
            <Avatar variant="square" />
          )}
        </Grid>
        <Grid item xs className="d-flex">
          <input {...getInputProps()} />
          <Button
            {...getRootProps()}
            disabled={(isEdit && previewImg !== null) || edit}
            className={classes.uploadBtn}
          >
            Upload
          </Button>
          {isEdit && previewImg != null || edit? (
            <IconButton disabled={isFlag === 1} onClick={() => handleRemoveImg()}>
              <BackspaceIcon />
            </IconButton>
          ) : null}
        </Grid>
        <Grid container className="mt-2">
          {/* {formik.values.logo.length > 0 ? files : null} */}
          {fileRejectionItems == "" ? validateImg : fileRejectionItems}
        </Grid>
      </Grid>
    );
  };
  
  export default DropZone;
  